import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import ProviderEncountersQuery from 'graphql/gql/providerEncounters';

export default Comp => {
  /* eslint-disable react/prefer-stateless-function */
  @withApollo
  class WithProviderEncounters extends Component {
    static propTypes = {
      client: PropTypes.object.isRequired,
      forwardedRef: PropTypes.object,
    };

    static defaultProps = {
      forwardedRef: null,
    };

    handleGetProviderEncounters = async variables => {
      const { client: apolloClient } = this.props;

      const { data } = await apolloClient.query({
        query: ProviderEncountersQuery,
        variables,
      });

      return data.providerEncounters;
    };

    handleEndEncounter = _id => {
      const { client: apolloClient } = this.props;
      const data = apolloClient.readQuery({ query: ProviderEncountersQuery });
      const newEncs = data.providerEncounters.nodes.filter(e => e._id !== _id);
      apolloClient.writeQuery({
        query: ProviderEncountersQuery,
        data: {
          providerEncounters: {
            ...data.providerEncounters,
            nodes: newEncs,
            totalCount: data.providerEncounters.totalCount - 1,
          },
        },
      });
    };

    render() {
      const { forwardedRef, ...props } = this.props;
      return (
        <Comp
          {...props}
          ref={forwardedRef}
          onGetProviderEncounters={this.handleGetProviderEncounters}
          onUpdateEncQCacheOnEndEnc={this.handleEndEncounter}
        />
      );
    }
  }

  return React.forwardRef((props, ref) => <WithProviderEncounters {...props} forwardedRef={ref} />);
};
